var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var Shuffle = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M3 6.75H5.16562C6.11941 6.75117 7.05918 6.9797 7.90699 7.41665C8.75481 7.8536 9.48624 8.48638 10.0406 9.2625L13.9594 14.7375C14.5138 15.5136 15.2452 16.1464 16.093 16.5833C16.9408 17.0203 17.8806 17.2488 18.8344 17.25H21.75M21.75 17.25L19.5 15M21.75 17.25L19.5 19.5M19.5 4.5L21.75 6.75M21.75 6.75L19.5 9M21.75 6.75H18.8344C17.8806 6.75117 16.9408 6.9797 16.093 7.41665C15.2452 7.8536 14.5138 8.48638 13.9594 9.2625L13.8469 9.42188M3 17.25H5.16562C6.11941 17.2488 7.05918 17.0203 7.90699 16.5833C8.75481 16.1464 9.48624 15.5136 10.0406 14.7375L10.1531 14.5781", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
